<template>
  <v-layout v-if="showNotification">
    <v-tooltip right :color="notificationColour">
      <div
        slot="activator"
        :class="notificationClass">
        <v-icon color="white" size="20" class="case-header-sla-icon">
          notifications_active
        </v-icon>
      </div>
      <span>{{notificationMessage}}</span>
    </v-tooltip>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "case-sla-notification",
  computed: {
    ...mapState({
      slas: state => state.cases.currentlySelected.case.serviceLevels
    }),
    showNotification() {
      return (this.slas && this.slas.length > 0)
    },
    breachList() {
      if (this.slas) {
        return this.slas.filter((sla) => sla.breachedAt !== null)
      }
      return []
    },
    jeopardyList() {
      if (this.slas) {
        return this.slas.filter((sla) => sla.jeopardizedAt !== null && sla.breachedAt === null)
      }
      return []
    },
    notificationClass() {
      if (this.breachList.length > 0) {
        return "case-header-sla breach"
      } else if (this.jeopardyList.length > 0) {
        return "case-header-sla jeopardy"
      } else {
        return "case-header-sla info--gradient"
      }
    },
    notificationColour() {
      if (this.breachList.length > 0) {
        return "error"
      } else if (this.jeopardyList.length > 0) {
        return "tertiary"
      } else {
        return "success"
      }
    },
    notificationMessage() {
      if (this.breachList.length > 0) {
        return this.breachList.length + " Overdue Service Levels"
      } else if (this.jeopardyList.length > 0) {
        return this.jeopardyList.length + " in Jeopardy"
      } else {
        return this.slas.length + " Service Levels"
      }
    }
  }
}
</script>
